import {Locale} from '@hebcal/hdate';
import poData from './fr.po.js';
Locale.addLocale('fr', poData);
